import { ShipmentCostRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ShipmentCostService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ShipmentCostRouteService());
	}

	findTn = filter => {
		const url = this.routeService.findTn(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	findCharge = filter => {
		const url = this.routeService.findCharge(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	uploadBillData(resource, isOverride, sourceOfChange) {
		const url = this.routeService.uploadBillData(isOverride, sourceOfChange);
		return this.apiClient.post(url, resource);
	}

	checkTrackingNumbers(resource) {
		const url = this.routeService.checkTrackingNumbers();
		return this.apiClient.post(url, resource);
	}
}

export default ShipmentCostService;



// WEBPACK FOOTER //
// ./src/common/data/services/ShipmentCostService.js